import Language from "../components/utils/Language";

export const locales = {
	NL: "nl",
	EN: "en",
	DE: "de"
};

export const isLocaleNL = locale => locale.toLowerCase() === locales.NL;
export const isLocaleDE = locale => locale.toLowerCase() === locales.DE;
export const isLocaleEN = locale => locale.toLowerCase() === locales.EN;

export const localeAsLanguageKey = locale => Language(`LANGUAGE_${locale.toUpperCase()}`);
